import { Home, Brain, ScrollText, Compass, FileText } from 'lucide-react';

export const SITE = 'cosmosres.com';

export const AREAS = [
  { id: 'home', label: 'Home', to: '/u99', icon: Home, blurb: 'The front door. What this is, who it is for, where to begin.' },
  { id: 'mind', label: "Kyle's Mind", to: '/u99/mind', icon: Brain, blurb: 'The connecting identity. One mind, several rooms.' },
  { id: 'doctrines', label: 'Doctrines', to: '/u99/doctrines', icon: ScrollText, blurb: 'Twenty structured statements, each in the same six-part frame.' },
  { id: 'tools', label: 'Psychology Tools', to: '/u99/tools', icon: Compass, blurb: 'Simple interactive instruments. They help you see; they do not diagnose.' },
  { id: 'documents', label: 'Documents', to: '/u99/documents', icon: FileText, blurb: 'Papers, notes and references — readable pages first, files as downloads.' },
];

export const LABELS = {
  'creative-doctrine': { name: 'Creative Doctrine', short: 'Doctrine', color: '#FBBF24', desc: 'A way of seeing. Written as conviction, offered as lens.' },
  'psychological-guidance': { name: 'Psychological Guidance', short: 'Guidance', color: '#22D3EE', desc: 'A practical frame for noticing and choosing. Never a diagnosis.' },
  'scientific-hypothesis': { name: 'Scientific Hypothesis', short: 'Hypothesis', color: '#34D399', desc: 'A testable claim. Stated so that it could be wrong.' },
  reference: { name: 'Reference', short: 'Reference', color: '#94A3B8', desc: 'Source material that makes no claim of its own.' },
};

export const CHAIN = ['Experience', 'Memory', 'Knowing', 'Emotion', 'Thought', 'Action', 'Trait'];

export const KINDS = {
  doctrine: { name: 'Doctrine', article: 'A', plural: 'Doctrines' },
  manuscript: { name: 'Manuscript', article: 'A', plural: 'Manuscripts' },
  thesis: { name: 'Thesis', article: 'A', plural: 'Theses' },
  novel: { name: 'Novel', article: 'A', plural: 'Novels' },
  book: { name: 'Book', article: 'A', plural: 'Books' },
  paper: { name: 'Paper', article: 'A', plural: 'Papers' },
  note: { name: 'Working Note', article: 'A', plural: 'Working Notes' },
  transcript: { name: 'Transcript', article: 'A', plural: 'Transcripts' },
  reference: { name: 'Reference', article: 'A', plural: 'References' },
  source: { name: 'Source Document', article: 'A', plural: 'Source Documents' },
  chapter: { name: 'Chapter', article: 'A', plural: 'Chapters' },
};
export const KIND_ORDER = ['manuscript', 'thesis', 'novel', 'paper', 'note', 'transcript', 'source', 'reference'];

export const TEMPLATE_PARTS = [
  { key: 'core_statement', n: '01', title: 'Core statement', hint: 'The doctrine in one breath.' },
  { key: 'plain_explanation', n: '02', title: 'Plain-language explanation', hint: 'For a reader with no background.' },
  { key: 'mechanism', n: '03', title: 'Proposed mechanism', hint: 'How it is imagined to work.' },
  { key: 'practical_meaning', n: '04', title: 'Practical meaning', hint: 'What changes if you take it seriously.' },
  { key: 'evidence_status', n: '05', title: 'Evidence status', hint: 'Observed, inferred, or speculated.' },
  { key: 'open_questions', n: '06', title: 'Open questions', hint: 'What would weaken or sharpen it.' },
];

export const SOUL_DNA_CAPTION = 'The intricate snowflake structures are implanted within the DNA, acting as blood cells. They represent the x-ray, gamma-ray, and microwave filter systems of the soul DNA — the internal binary flow.';
export const HERO_PLASMA = '/u99/helix-snowflake-blood-cells.jpg';
export const HERO_HELIX = '/u99/helix-snowflake-blood-cells.jpg';
export const SOUL_DNA_IMAGE = '/u99/helix-snowflake-blood-cells.jpg';
